<template>
  <div class="main" v-title data-title="北京天蔚中医药发展促进中心-关于我们">
    <div class="swipe">
      <img src="http://123.56.170.62:9999/static/bg/banner5.png" alt />
    </div>
    <Class :nav="nav"></Class>
  </div>
</template>
<script>
import Class from "@/components/Class.vue"
import Bus from "@/utils/bus.js"
export default {
  data() {
    return {
      nav: [
        { title: "公司信息", url: "gsxx" },
        { title: "组织结构", url: "zzjg" },
        { title: "成长历程", url: "czlc" },
        { title: "联系我们", url: "lxwm" },
      ],
    }
  },
  mounted() {
    this.$nextTick(function() {
      Bus.$emit("getCurrent", "conntect")
    })
  },
  methods: {},
  components: {
    Class,
  },
}
</script>

<style lang="less" scoped>
.main {
  width: 100%;
  .swipe {
    width: 100%;
    img {
      width: 100%;
      height: 400px;
    }
  }
}
</style>
